import Base from './base';

import { BACKGROUND_IMAGE_CONTAINER_SELECTOR } from '../../classnames/lazyload';
import { HIDDEN } from '../../classnames/design-system';

export default class BackgroundImage extends Base {
  selector = BACKGROUND_IMAGE_CONTAINER_SELECTOR;

  load = (element) => {
    const { backgroundPlaceholderImage, backgroundOriginalImage } = element.dataset;

    if (backgroundPlaceholderImage) {
      this.setBackgroundImage(element, backgroundPlaceholderImage);

      this.loadImage(backgroundOriginalImage, () => {
        this.setBackgroundImage(element, backgroundOriginalImage);
      });
    }
  };

  loadImage = (image, callback) => {
    const imageNode = new Image();

    imageNode.addEventListener('load', callback);
    imageNode.src = image;
    imageNode.classList.add(HIDDEN);
    document.querySelector('body').appendChild(imageNode);
  };

  setBackgroundImage = (element, image) => element.style.backgroundImage = `url(${image})`;
}
